<template>
  <a-modal
    v-model="visible"
    :width="800"
    title="委托找仓"
    centered
    class="FindWarehouse"
  >
    <div>
      <a-form-model ref="FindWareHouseForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="联系人姓名" prop="contacts">
          <a-input v-model="form.contacts" :max-length="30" placeholder="请输入您的姓名" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="telPhone">
          <a-input v-model="form.telPhone" :max-length="11" placeholder="请输入您的手机号" />
        </a-form-model-item>
        <a-form-model-item label="需求位置" prop="list">
          <a-cascader
            ref="cascaderDom"
            v-model="form.list"
            class="cascader"
            :options="options"
            :allow-clear="false"
            expand-trigger="hover"
            placeholder="请选择需要找仓城市"
            @change="onChange"
          />
        </a-form-model-item>
        <a-form-model-item label="需求面积" prop="area">
          <a-input v-model="form.area" type="number" placeholder="请输入需求面积" suffix="㎡" />
        </a-form-model-item>
        <a-form-model-item label="温区要求">
          <a-checkbox-group
            v-model="form.temperatureZones"
            name="checkboxgroup"
            :options="TEMPERATURES"
          />
        </a-form-model-item>
        <a-form-model-item label="仓库类型">
          <a-checkbox-group
            v-model="form.storeTypes"
            name="checkboxgroup"
            :options="plainOptions"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template slot="footer">
      <span class="tips"><a-icon type="exclamation-circle" />提交后将有专属经理为您服务</span>
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" v-track-click="{trackName: '我要寻仓-委托找仓'}" type="primary" @click="onSubmit">
        确认
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { programme } from '../api'
import { TEMPERATURES } from '../constant'

export default {
  name: 'FindWarehouse',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    warehouseList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value*1 < 0 || value*1 > 99999) {
        callback(new Error('0＜面积＜99999'));
      }  else {
        callback();
      }
    };
    return {
      visible: false,
      form: {
        storeTypes: [],
        contacts: '',
        telPhone: '',
        area: '',
        list: [],
        temperatureZones: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        type: 'DELEGATE_SEARCH'
      },
      TEMPERATURES,
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      rules: {
        contacts: [
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],
        telPhone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^\d{1,11}$/, message: '请输入正确的手机号', trigger: 'change' },
        ],
        list: [
          { required: true, message: '请选择需要找仓城市', trigger: 'change' },
        ],
        area: [
          { validator: validatePass2, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    plainOptions(){
      const list = this.warehouseList.filter((e) => {
        return e.code !== ''
      })
      return list.map((e) => {
        return {
          ...e,
          value: e.name,
          label: e.name
        }
      })
    }
  },
  methods: {
    show(){
      this.visible = true
      this.$refs.FindWareHouseForm.resetFields()
      this.remove()
    },
    onChange(value, selectedOptions){
      this.form.provinceCode =  selectedOptions[0].areaCode
      this.form.provinceName =  selectedOptions[0].areaName
      this.form.cityCode =  selectedOptions[1].areaCode
      this.form.cityName =  selectedOptions[1].areaName
      this.form.countyCode =  selectedOptions[2].areaCode
      this.form.countyName =  selectedOptions[2].areaName
    },
    async onSubmit(){
      try {
        await this.$refs.FindWareHouseForm.validate()
      } catch {
         this.$message.warning('输入不正确')
         return
      }
      await programme({
        ...this.form,
        customerCode: this.$store.state.user.customerCode,
        tenantId: this.$store.state.user.tenantId,
      }).then(()=>{
        this.visible = false
        this.$notification.open({
          message: '您的需求发布成功',
          description:
            '您的专属经理将尽快与你联系',
          icon: <a-icon type="check-circle" style="color: #25c48d" />,
        });
      })
    },
    handleCancel() {
      this.visible = false
    },
    remove(){
      this.$set(this, 'form',{
        storeTypes: [],
        contacts: '',
        telPhone: '',
        area: '',
        list: [],
        temperatureZones: [],
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        type: 'DELEGATE_SEARCH'
      })
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-form-item-control-wrapper{
  display: inline-block !important;
}
.tips{
  color: #909399;
  font-size: 14px;
  float: left;
  line-height: 34px;
  i{
    margin-right: 8px;
  }
}
</style>